import React, { useEffect, useRef } from "react";
import L from "leaflet";

export default function Map({ points = [] }) {
  const mapRef = useRef(null);

    const mapInstanceRef = useRef(null);
    const polylineRef = useRef(null);
    useEffect(() => {
      if (!mapRef.current || mapInstanceRef.current) return;
      const map = L.map(mapRef.current);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
      }).addTo(map);
      mapInstanceRef.current = map;
      return () => {
        if (mapInstanceRef.current) {
          mapInstanceRef.current.remove();
          mapInstanceRef.current = null;
        }
        if (polylineRef.current) {
          polylineRef.current = null;
        }
      };
    }, []);
    // Update map when points change
    useEffect(() => {
      const map = mapInstanceRef.current;
      if (!map || !points.length) return;
      const latlngs = points.map((p) => [p.lat, p.lng]);
      if (polylineRef.current) {
        map.removeLayer(polylineRef.current);
        polylineRef.current = null;
      }
      if (latlngs.length === 1) {
        map.setView(latlngs[0], 15);
      } else if (latlngs.length > 1) {
        const polyline = L.polyline(latlngs, { weight: 4 }).addTo(map);
        polylineRef.current = polyline;
        map.fitBounds(latlngs);
      }
  }, [points]);

  return <div ref={mapRef} style={{ height: "450px", borderRadius: "10px", marginBottom: "30px" }} />;
}
